if (typeof window.productCalculator !== 'undefined') {
  var currentTilePrice = parseFloat(window.productCalculator.currentTilePrice);
  var soldAsBox = window.productCalculator.soldAsBox;
  var tilesPerBox = parseInt(window.productCalculator.tilesPerBox) || 1;
  var perM2 = parseFloat(window.productCalculator.perM2) || 1;
  var allowSingleUnits = window.productCalculator.allowSingleUnits || false;
  var minTileQtyEnable = window.productCalculator.minTileQtyEnable !== undefined ? window.productCalculator.minTileQtyEnable : true;
  var inventoryPolicy = window.productCalculator.inventoryPolicy || 'continue'; // Default to continue if undefined
  var inventoryQuantity = parseInt(window.productCalculator.inventoryQuantity) || 0;

  var productType = (window.productCalculator.productType || '').toLowerCase();

  /**
   * Round up quantity to the next full box multiple
   * @param {number} quantity - The quantity to round up
   * @returns {number} - Rounded up quantity
   */
  function roundUpToBoxMultiple(quantity) {
    if (!minTileQtyEnable) {
      return quantity;
    }
    // Only allow single units if minTileQtyEnable is false OR soldAsBox is false
    if (allowSingleUnits && !soldAsBox) {
      return quantity;
    }
    // Also ensuring tilesPerBox > 1
    if (tilesPerBox <= 1 || !productType.includes('tile')) {
      return quantity;
    }
    return Math.ceil(quantity / tilesPerBox) * tilesPerBox;
  }

  function checkStockStatus(currentQty) {
    var messageEl = $('.tiles-min-order-message');
    var buttonsToDisable = $('#AddToCart, #addToBasket, #StartOrder, #StartOrder2, #continueBtn, #SkipExtrasBtn, .shopify-payment-button button');

    // Initialize with default or empty
    var defaultMessage = '';
    var errorMessage = '';

    if (inventoryPolicy === 'deny') {
      if (inventoryQuantity < (soldAsBox ? tilesPerBox : 1)) {
        errorMessage = 'Not enough stock available.';
      } else if (currentQty > inventoryQuantity) {
        errorMessage = 'Not enough stock available. Only ' + inventoryQuantity + ' in stock.';
      }
    }

    if (errorMessage !== '') {
      messageEl.text(errorMessage).show();
    } else {
      messageEl.text(defaultMessage);
      if (defaultMessage === '') messageEl.hide();
      else messageEl.show();
    }
  }

  $(document).ready(function () {
    // Disable native browser validation — hidden inputs (M2, width) cause
    // "invalid form control not focusable" error when form submits.
    // Our custom JS handles all validation logic.
    $('#M2').closest('form').attr('novalidate', true);

    // Initial check
    checkStockStatus();

    function triggerNextStep() {
      if ($('#StartOrder2').is(':visible')) {
        $('#StartOrder2').trigger('click');
      } else if ($('#AddToCart:visible, #SkipExtrasBtn:visible').length > 0) {
        $('#AddToCart:visible, #SkipExtrasBtn:visible').first().trigger('click');
      }
    }

    function calcTiles() {
      var M2Val = $('#M2').val() || '';
      var M2 = parseFloat(M2Val.toString().replace(',', '.')) || 0;
      var totalTiles1 = M2 * perM2;
      var totalTiles = Math.ceil(totalTiles1 - 0.0001);

      // Apply 10% wastage FIRST if checkbox is checked
      if ($('#wastage').is(':checked')) {
        totalTiles = Math.ceil(totalTiles * 1.1 - 0.0001);
      }

      var requiredTiles = totalTiles; // Real needed quantity for the area

      // THEN round up to the nearest box multiple
      if (tilesPerBox > 1) {
        totalTiles = roundUpToBoxMultiple(totalTiles);
      }

      var totalArea = (totalTiles / perM2).toFixed(3);

      var totalBoxes = Math.ceil(totalTiles / tilesPerBox);
      // Update ALL quantity inputs
      if (soldAsBox) {
        $('.realQty').val(totalBoxes);
      } else {
        $('.realQty').val(totalTiles);
      }
      $('#realM2').val(totalArea + 'm2');

      displayTotals(totalTiles, totalArea, requiredTiles);
      checkStockStatus(totalTiles);

      /* Process Surface area lines */
      if (!$('#areaMulti').is(':checked')) {
        var intLines = parseInt($('#calculator').attr('data-lines'));
        if (intLines == 1) {
          var line = $('#calculator').find('.line').last();
          $(line).find('[name="width"]').val(M2);
          $(line).find('[name="height"]').val(1);
          $(line).attr('data-area', M2);
        }
      }
    }

    function calcM2(e) {
      var isFromTabSwitch = e === false;
      // ALWAYS read from the currently active input to avoid locked values
      var activeInputRaw = $(e && e.target ? e.target : '.realQty:visible').val() || $('.realQty').first().val() || '';
      var inputVal = parseInt(activeInputRaw.toString().replace(',', '.')) || 0;
      var totalTiles = soldAsBox ? inputVal * tilesPerBox : inputVal;

      if (tilesPerBox > 1 && !allowSingleUnits) {
        totalTiles = roundUpToBoxMultiple(totalTiles);
        if (!isFromTabSwitch) {
          if (soldAsBox) {
            $('.realQty').val(totalTiles / tilesPerBox);
          } else {
            $('.realQty').val(totalTiles);
          }
        }
      }

      var totalArea = (totalTiles / perM2).toFixed(3);

      $('#realM2').val(totalArea + 'm2');
      if (!isFromTabSwitch) {
        $('#M2').val(totalArea);
      }
      displayTotals(totalTiles, totalArea, totalTiles);
      checkStockStatus(totalTiles);

      /* Process Surface area lines */
      if (!isFromTabSwitch) {
        var intLines = parseInt($('#calculator').attr('data-lines'));
        if (intLines == 1) {
          var line = $('#calculator').find('.line').last();
          $(line).find('[name="width"]').val(totalArea);
          $(line).find('[name="height"]').val(1);
          $(line).attr('data-area', totalArea);
        }
      }
    }

    /* Initialise */
    $(function () {
      if (perM2 > 0 || tilesPerBox > 1) {
        // Initialize based on active tab
        if ($('input[name="order_by"]:checked').val() === 'tiles' || tilesPerBox > 1) {
          calcM2();
        } else {
          calcTiles();
        }

        // Sync all realQty inputs instantly to whatever is typed
        $('.realQty').on('input', function (e) {
          var typedVal = $(this).val();
          $('.realQty').not(this).val(typedVal);
        });

        // Immediate calc on blur for #M2
        $('#M2').on('blur', function () {
          calcTiles();
        });

        // Immediate calc on programmatic change (from qty buttons) for #M2
        $('#M2').on('change', function () {
          calcTiles();
        });

        // Immediate calc on blur for .realQty
        $('.realQty').on('blur', function (e) {
          calcM2(e);
        });

        // Immediate calc on programmatic change (from qty buttons) for .realQty
        $('.realQty').on('change', function (e) {
          var typedVal = $(this).val();
          $('.realQty').not(this).val(typedVal);
          calcM2(e);
        });

        $('#wastage').on('change', function () {
          if ($('input[name="order_by"]:checked').val() === 'tiles') {
            calcM2();
          } else {
            calcTiles();
          }
        });

        // Crucial: Switch listener
        $('input[name="order_by"]').on('change', function () {
          // No recalculation needed on tab switch as inputs are already synchronized
        });

        $('#M2').on('keypress', function (e) {
          if (e.which === 13) {
            e.preventDefault();
            $(this).blur();
            calcTiles();
            triggerNextStep();
          }
        });

        $('.realQty').on('keypress', function (e) {
          if (e.which === 13) {
            e.preventDefault();
            $(this).blur();
            calcM2();
            triggerNextStep();
          }
        });

        bindSurfaces();
      }

      $('#link_description').click(function (e) {
        e.preventDefault();
        window.scrollTo({
          behavior: 'smooth',
          top: $('.long_description:visible')[0].getBoundingClientRect().top - document.body.getBoundingClientRect().top - 0,
        });
      });
    });

    function calcSurfaces() {
      var intLines = parseInt($('#calculator').attr('data-lines'));
      var lines = $('#calculator').find('.line');
      var totalArea = 0;
      for (i = 0; i < intLines; i++) {
        var areaVal =
          $(lines)
            .eq(i + 1)
            .attr('data-area') || '';
        totalArea += parseFloat(areaVal.toString().replace(',', '.')) || 0;
      }
      $('#M2').val(totalArea);
      calcTiles();
    }

    function bindSurfaces() {
      $('input[name="width"], input[name="height"]')
        .off('input')
        .on('input', function (e) {
          var thisLine = $(this).closest('.line');
          var widthVal = $(thisLine).find('input[name="width"]').val() || '';
          var heightVal = $(thisLine).find('input[name="height"]').val() || '';
          var width = parseFloat(widthVal.toString().replace(',', '.')) || 0;
          var height = parseFloat(heightVal.toString().replace(',', '.')) || 0;
          if (width > 0 && height > 0) {
            $(thisLine).attr('data-area', (width * height).toFixed(2));
            calcSurfaces();
          }
        });
    }

    function displayTotals(totalTiles, totalArea, requiredTiles) {
      const passTotalTilesToProductUpsellJs = new CustomEvent('passTotalTilesToProductUpsellJs', {
        detail: { totalTiles: totalTiles },
      });
      document.dispatchEvent(passTotalTilesToProductUpsellJs);

      var wastageSuffix = '';
      if ($('#wastage').is(':checked')) {
        // Only show "(with 10% wastage)" if it actually affected the final count (i.e. if it's from calcTiles)
        // For now, let's keep it simple: show it if checked, but ensure it doesn't imply the area IS wastage
        wastageSuffix = ' (with 10% wastage)';
      }
      var totalBoxes = Math.ceil(totalTiles / tilesPerBox);

      var realNeedText =
        requiredTiles && requiredTiles != totalTiles
          ? " <span class='text_small' style='display:block; font-size: 0.8em; margin-top: 2px; color: #666;'>Exact requirement for your area: " +
            requiredTiles +
            ' tiles</span>'
          : '';

      if (soldAsBox) {
        var totalPrice = ((totalBoxes * currentTilePrice) / 100).toFixed(2);
        $('.total-price').html("£<span class='totalTilePrice'>" + totalPrice + '</span>');
        $('.total-tiles-m2').html(
          "<span class='tileQtyWithWastage'>" +
            totalBoxes +
            '</span> Box' +
            (totalBoxes > 1 ? 'es' : '') +
            ' / ' +
            totalArea +
            'm²' +
            wastageSuffix +
            realNeedText +
            "<span class='upsellExtrasNote'> + Extras</span>",
        );
      } else {
        var totalPrice = ((totalTiles * currentTilePrice) / 100).toFixed(2);
        var boxDetail = tilesPerBox > 1 ? ' (' + totalBoxes + ' Boxes)' : '';

        $('.total-price').html("£<span class='totalTilePrice'>" + totalPrice + '</span>');
        $('.total-tiles-m2').html(
          "<span class='tileQtyWithWastage'>" +
            totalTiles +
            '</span> Tile' +
            (totalTiles > 1 ? 's' : '') +
            boxDetail +
            ' / ' +
            totalArea +
            'm²' +
            wastageSuffix +
            realNeedText +
            "<span class='upsellExtrasNote'> + Extras</span>",
        );
      }

      // Re-evaluate stock status every time totals are displayed (e.g. though unlikely to change without page reload, valid for completeness)
      // checkStockStatus(); // redundant now as called in displayTotals
    }
  });
}
